const DEFAULT_STATUS_MESSAGES = {
  401: "Your session has expired. Please sign in again.",
  403: "You do not have permission to perform this action.",
  404: "The requested resource was not found or is outside your access scope.",
  409: "This action conflicts with the current state of the resource.",
  501: "This action is intentionally unavailable on the Nest backend for now.",
};

export const getApiErrorStatus = (error) => {
  const directStatus = Number(error?.status);
  if (Number.isFinite(directStatus) && directStatus > 0) {
    return directStatus;
  }

  const payloadStatus = Number(error?.data?.statusCode || error?.data?.code);
  if (Number.isFinite(payloadStatus) && payloadStatus > 0) {
    return payloadStatus;
  }

  return null;
};

export const getApiErrorMessage = (
  error,
  fallback = "Something went wrong",
  statusMessages = {},
) => {
  const status = getApiErrorStatus(error);
  const resolvedStatusMessage = {
    ...DEFAULT_STATUS_MESSAGES,
    ...statusMessages,
  }[status];

  if (resolvedStatusMessage) {
    return resolvedStatusMessage;
  }

  const validationDetails = error?.data?.details;
  if (Array.isArray(validationDetails) && validationDetails.length > 0) {
    return validationDetails.join(", ");
  }

  return (
    error?.data?.message ||
    error?.error ||
    error?.message ||
    fallback
  );
};
